import { PageHero } from '@/components/common/Sections';
import { IMAGES, COMPANY_INFO } from '@/lib/constants';

export default function TermsPage() {
  return (
    <div className="page-transition">
      <PageHero title="Terms & Conditions" subtitle="Please read these terms carefully before using our services" backgroundImage={IMAGES.airport} />

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="space-y-8 text-[#4A5568] leading-relaxed">

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">1. Introduction</h2>
              <p>Welcome to {COMPANY_INFO.name}. These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms. If you do not agree, please do not use our services.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">2. Services</h2>
              <p className="mb-3">{COMPANY_INFO.name} provides travel management services including but not limited to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Air ticketing and flight bookings</li>
                <li>Visa and passport processing assistance</li>
                <li>Foreign exchange services</li>
                <li>Tour packages and holiday planning</li>
                <li>Corporate travel management</li>
                <li>Study abroad consultancy</li>
                <li>Travel insurance facilitation</li>
                <li>Document attestation services</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">3. Booking & Payment</h2>
              <p className="mb-3">All bookings are subject to availability and confirmation. Prices quoted are subject to change without prior notice until a booking is confirmed. Payment terms vary by service and will be communicated at the time of booking.</p>
              <p>Full payment or applicable deposit must be received before services are rendered unless a corporate credit arrangement is in place.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">4. Cancellation & Refund Policy</h2>
              <p className="mb-3">Cancellation policies vary depending on the type of service booked. Airline tickets, hotel reservations, and tour packages are subject to the cancellation policies of the respective service providers.</p>
              <p>{COMPANY_INFO.name} service fees may be non-refundable. Refunds, where applicable, will be processed as per the respective service provider's policy and may take up to 30 business days.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">5. Visa & Passport Services</h2>
              <p>{COMPANY_INFO.name} acts as a facilitator for visa and passport applications. We do not guarantee visa approval as the final decision rests with the respective embassy or consulate. Processing times are estimates and may vary. All documentation fees are non-refundable regardless of the outcome.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">6. Travel Insurance</h2>
              <p>We strongly recommend purchasing comprehensive travel insurance for all trips. {COMPANY_INFO.name} facilitates insurance purchases but is not the insurer. All claims and coverage are subject to the insurance provider's terms and conditions.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">7. Limitation of Liability</h2>
              <p>{COMPANY_INFO.name} acts as an intermediary between travelers and service providers (airlines, hotels, embassies, etc.). We shall not be liable for any loss, damage, or inconvenience caused by factors beyond our control, including but not limited to flight delays, cancellations, natural disasters, government regulations, or service provider failures.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">8. Intellectual Property</h2>
              <p>All content on this website, including text, graphics, logos, and images, is the property of {COMPANY_INFO.name} and is protected by applicable copyright laws. Unauthorized use, reproduction, or distribution of any content is strictly prohibited.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">9. Governing Law</h2>
              <p>These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Ernakulam, Kerala.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">10. Contact</h2>
              <p>For questions regarding these terms, please contact us at <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#D4AF37] hover:underline">{COMPANY_INFO.email}</a> or call <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#D4AF37] hover:underline">{COMPANY_INFO.phone}</a>.</p>
            </div>

            <p className="text-sm text-[#4A5568]/70 border-t border-slate-200 pt-6">Last updated: March 2026</p>
          </div>
        </div>
      </section>
    </div>
  );
}
